import { useRef, useEffect, useState } from "react";

export const useElementPosition = () => {
  const elementRef = useRef(null);
  const [position, setPosition] = useState({
    top: 0,
    left: 0,
    windowHeight: 0,
    pageHeight: 0,
  });

  useEffect(() => {
    const updatePosition = () => {
      if (elementRef.current) {
        const rect = elementRef.current.getBoundingClientRect();
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft =
          window.pageXOffset || document.documentElement.scrollLeft;
        const pageHeight = document.documentElement.scrollHeight;
        const windowHeight = window.innerHeight;
        setPosition({
          top: scrollTop,
          left: scrollLeft,
          pageHeight: pageHeight,
          windowHeight: windowHeight,
        });
      }
    };

    updatePosition();

    window.addEventListener("scroll", updatePosition);
    window.addEventListener("resize", updatePosition);

    return () => {
      window.removeEventListener("scroll", updatePosition);
      window.removeEventListener("resize", updatePosition);
    };
  }, []);

  return [elementRef, position];
};
